import { ApiItemType } from '@ibe/api';
import {
  faBed,
  faBus,
  faCar,
  faLayerGroup as defaultIcon,
  faPlane,
  faStar,
  faSuitcase,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons/faShieldAlt';

const getIconForItemTye = (type: ApiItemType): IconDefinition => {
  if (type === ApiItemType.TRANSPORT) {
    return faBus;
  }
  if (type === ApiItemType.HOTEL) {
    return faBed;
  }
  if (type === ApiItemType.EXTRA) {
    return faStar;
  }
  if (type === ApiItemType.INSURANCE) {
    return faShieldAlt;
  }
  if (type === ApiItemType.FLIGHT) {
    return faPlane;
  }
  if (type === ApiItemType.CAR) {
    return faCar;
  }
  if (type === ApiItemType.PACKAGE) {
    return faSuitcase;
  }
  return defaultIcon;
};

export default getIconForItemTye;
